<div *ngIf="display$ | async as display">
  <section [class.open]="display === 'open'"
  (click)="close()">
  <div (click)="$event.stopPropagation()"
  [ngClass]="showFileUploadArea ? 'custom-modal-float-dialog-container' : 'mini-custom-modal-float-dialog-container'">
  <h2 style="padding: 24px 24px 0 24px ;margin-top: 20px;" class="mobile-padding"  *ngIf="showFileUploadArea" >Uploads</h2>
  <div class="main-wrapper">
     <div style="padding:24px;" *ngIf="showFileUploadArea" class="common-upload-table flex fl-col width-100per">
        <!-- COMMON HEADER -->
        <div class="common-upload-table__header flex width-100per" style="padding-left: 12px;">
           <p style="min-width: 40%;" class="width-40per flex fl-al-center set-mobile-witdh">FILE</p>
           <p class="width-20per flex fl-al-center mobile-witdh-size" style="padding-left: 28px;" >SIZE</p>
           <p  style="min-width: 25%;" class="width-25per flex fl-al-center hide-on-mobilile">DESTINATION</p>
           <p class="width-15per flex fl-al-center mobile-witdh-status" style="justify-content: flex-end;padding-right: 12px;" >STATUS</p>
        </div>
        <!-- COMMON BODY -->
        <div class="width-100per"  *ngFor="let node of fileListDataTree; let i = index">

        <div style="display: flex;flex-direction: column;width: 100%;    margin-top: 6px;
        border-bottom: 1px solid #D3DCE8;
        padding: 6px 0px;
        margin-bottom: 6px;">
                  <div style="display: flex;flex-direction: row;" >
                     <div  
                     style="min-width: 40%;"
                     [ngClass]="checkIsFile(node.data.isDirectory,node.data,node.name) ? 'mltop12' : 'mltop12'"
                     class="width-40per  set-mobile-witdh flex-align-center flex custom-button mostly-customized-scrollbar">
                        
                        <img src="assets/images/folder-icon.svg" *ngIf="checkIsFile(node.data.isDirectory,node.data,node.name); else showFile" />
                        <ng-template #showFile>
                           <img src="assets/images/file-icon.svg" />
                        </ng-template>
                        <p class="ml-10 text-truncate" >
                           {{ node.name }}
                        </p>
                     </div>
                     <div class="width-20per flex-align-center mobile-witdh-size">
                        <p class="title">
                           {{ getSizeInUnits(node.data,node.name) }}
                        </p>
                     </div>
                     <div style="min-width: 25%;" class="width-25per flex-align-center hide-on-mobilile" matTooltip="{{ node.data.fullPath }}">
                        <p class="sub-title text-truncate">
                           <!-- {{ node.data.fullPath | truncateStrPipe: 15 }} -->
                           {{ node.data?.fullPath |  bulkFileUploadedUrl : node }}
                        </p>
                     </div>
                     <div class="width-15per flex-align-center mobile-witdh-status" 
                     [ngClass]="checkIsFile(node.data.isDirectory,node.data,node.name) ? '' : 'mlzero-positive'"
                     style="text-align: -webkit-right;padding-right: 24px;" >
                        <div *ngIf="checkFileuploadIsdone(node.data?.fullPath) == 'running'"  class="spinner-finished ml-10">
                           <mat-spinner [diameter]="20"></mat-spinner>
                        </div>
                        <div *ngIf="checkFileuploadIsdone(node.data?.fullPath) == 'success'"   class="spinner-finished ml-10">
                           <img src="assets/images/completed-check.svg" />
                        </div>
                        <div *ngIf="checkFileuploadIsdone(node.data?.fullPath) == 'fail'"   class="spinner-finished ml-10">
                           X
                        </div>
                     </div>
    
                  </div>
                  <div class="show-on-mobile" >
                     <p class="sub-title text-truncate location-div" >
                        <!-- {{ node.data.fullPath | truncateStrPipe: 15 }} -->
                        {{ node.data?.fullPath |  bulkFileUploadedUrl : node }}
                     </p>
                  </div>

               </div>        </div>
        <div style="width:100%" *ngIf="showLader" >
          <div  class="ph-item firstelement" style="border: 0px;" >
             <div  class="ph-col-12" style="padding: 0px !important;">
                <div class="ph-item" style="padding: 0px !important;border: 0px !important;margin: 0px;height: 14px;">
                   <div>
                      <div class="ph-row">
                         <div class="ph-col-12 big"></div>
                      </div>
                   </div>
                </div>
             </div>
             <div  class="ph-col-12" style="padding: 0px !important;">
                <div class="ph-item" style="padding: 0px !important;border: 0px !important;margin: 0px;height: 14px;">
                   <div>
                      <div class="ph-row">
                         <div class="ph-col-12 big"></div>
                      </div>
                   </div>
                </div>
             </div>
             <div  class="ph-col-12" style="padding: 0px !important;">
                <div class="ph-item" style="padding: 0px !important;border: 0px !important;margin: 0px;height: 14px;">
                   <div>
                      <div class="ph-row">
                         <div class="ph-col-12 big"></div>
                      </div>
                   </div>
                </div>
             </div>
          </div>
       </div>
  
     </div>
     <div class="action-footer">
        <div class="flex-center">
           <button mat-raised-button  (click)="RevieSHowFile()" >
           <i class="material-icons">
           {{showFileUploadArea? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}          
           </i>
           </button>
           <p *ngIf="itemCounter"

           
           class="ml-10 text-white " style="display: flex;">
              <span style="font-weight: 400;">
              {{fileCompltedStack.length }} 
              </span> 
              <span style="font-weight: 400;" >
                /{{ itemCounter }}  
              </span>
              <span *ngIf="!showFileUploadArea" style="margin-left: 12px;font-size: 24px;" class="material-icons add-item-icon show-on-mobile">upload</span>
              <span  [ngClass]="showFileUploadArea ? '' : 'hide-on-mobilile'">
               &nbsp;  {{itemCounter == 1 ? 'File': 'Files' }} Uploaded
              </span>
           </p>
        </div>
        <div>
           <button *ngIf="(!(itemCounter-fileCompltedStack.length) && itemCounter)" (click)="DoneCliek()" mat-raised-button>Done</button>
           <button 
           [ngClass]="showFileUploadArea ? '' : 'hide-on-mobilile'"
           *ngIf="(itemCounter-fileCompltedStack.length) && screenWidth>650"  mat-raised-button>
           {{itemCounter-fileCompltedStack.length}} {{itemCounter-fileCompltedStack.length == 1 ? 'Item':'Items'}} Remaining
         </button>
         <button 
         [ngClass]="showFileUploadArea ? '' : 'hide-on-mobilile'"
         *ngIf="(itemCounter-fileCompltedStack.length) && screenWidth<650"  mat-raised-button>
         Uploading
       </button>
        </div>
     </div>
  </div>
</div>
</section>
</div>